/* eslint-disable prettier/prettier */
/* prettier-ignore */

import { MvnCodeInitiate } from "../../lib/const";

export const DOCS_TEMPLATE_CODE: {} = {};

MvnCodeInitiate(DOCS_TEMPLATE_CODE);
